import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getDivisionList(parentId) {
  return request({
    url: URL.mdm.divisionByParentId,
    method: 'get',
    params: { parentId }
  })
}

export function queryDivisionByName(data) {
  return request({
    url: URL.mdm.queryDivisionByName,
    method: 'post',
    data
  })
}
